module.exports = __webpack_public_path__ + "img/main_music_l720.a809d748.png";